/**
 * Select component
 * @returns <Select />
 */
import { useState, useEffect } from "react";
import { useMediaQuery } from "usehooks-ts";
import Drawer from "./Drawer";

const Select = (props) => {
  const {
    type,
    id,
    name,
    label,
    isRequired,
    dropdownItems,
    placeholder,
    selectChangeHandler
  } = props;

  // State
  const isAboveTablet = useMediaQuery("(min-width: 720px)");

  const [selectedItem, setSelectedItem] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  // const [error, setError] = useState(false);

  // Drawer state
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const onClickHandler = (e) => {
    setSelectedItem(e.target.dataset.index)
    selectChangeHandler(e.target.dataset.value)
    setIsOpen(false);
    setIsDrawerOpen(false);
  }

  const openDropdownHandler = (e) => {
    setIsOpen(!isOpen);
  }

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  }

  useEffect(() => {
    if (isDrawerOpen) {
      document.body.classList.add("no-scroll")
    } else {
      document.body.classList.remove("no-scroll")
    }
  }, [isDrawerOpen])

  const dropdownList = dropdownItems.map((item, i) => {
    return (
      <li className="input__select__dropdown__item" data-value={item.dataValue} data-index={i} onClick={onClickHandler} key={i}>{item.label}</li>
    )
  })

  const drawerContent = (
    <ul>
      {dropdownItems.map((item, i) => {
        return (
          <li className="input__select__dropdown__item" data-value={item.dataValue} data-index={i} onClick={onClickHandler} key={i}>{item.label}</li>
        )
      })}
    </ul>
  )

  // Text
  if (type === "select") {
    return (
      <div className="input">
        <div className={`input__field input__select --filled ${isOpen ? "--focus" : ""}`}>
          <div className="input__select__wrapper">
            {/* <input className={`hidden-control`} type="hidden" name={name} required={isRequired ? true : false} defaultValue={inputValue} /> */}
            <label htmlFor={name} className={`input__select__label --floating-label`}>{label}</label>

            <div className={`input__select__controls ${isOpen ? "--open" : ""}`} onClick={isAboveTablet ? openDropdownHandler : toggleDrawer}>
              <span className="input__select__placeholder">
                {selectedItem ? dropdownItems[selectedItem].label : placeholder}
              </span>
              <i className="caret"></i>
            </div>
          </div>

          <div className="input__select__dropdown">
            <ul className={`input__select__dropdown__list ${isOpen ? "--open" : ""}`}>
              {dropdownList}
            </ul>
          </div>
        </div>

        {/* Message box to display a message 
            types: ok, error
        */}
        {/* <div className="input__message">
          <img src={imageSrc} alt="" />

          <p>Hubo un error</p>
        </div> */}

        <Drawer title={"Selecciona una opción"} content={drawerContent} isOpen={isDrawerOpen} close={toggleDrawer} />
      </div>
    )
  }
}

export default Select